import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { Section } from "../../../ui/Section/Section";
import { SectionHeading } from "../Common/SectionHeading";

type PackageDescriptionProps = {
  part: PackagePartItem | null;
};

export const PackageDescription: FunctionComponent<PackageDescriptionProps> = ({
  part,
}) => {
  const [language] = useLanguage();
  const description =
    part?.partDetails.primaryPart.packageDescription[language];
  if (!description) {
    return null;
  }
  return (
    <Section>
      <SectionHeading translation="searchResults.description" />
      <p className="text-xs">{description}</p>
    </Section>
  );
};
